import { Fade, LinearProgress, Slide } from '@mui/material';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../../../../Components/Modal/Modal';
import { Button, Input } from '../../../../Components/StyledComponents';
import CreateOptionGroup from './CreateOptionGroup';
import ReactDragListView from 'react-drag-listview';
import './OptionGroupInfo.scss';
import axios from 'axios';
import { alertRef } from '../../../../App';
import ModifyOptionGroup from './ModifyOptionGroup';
import { tableOrderSync } from '../../../../Utils/services';
import { languageText } from '../../../../Utils/functions';

const OptionGroupInfo = () => {
    const [isDrag, setIsDrag] = React.useState(false)
    const [list, setList] = React.useState([])
    const [data, setData] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(true)

    const modalRef = React.useRef(null);
    const modalModRef = React.useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        getOptionGroup();
    }, [])

    const getOptionGroup = () => {
        setIsLoading(true)
        axios.get('/api/table/order/menu/option/group')
            .then((data) => {
                setList(data.data)
                setIsLoading(false)
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            if (!isDrag) return;
            const data = [...list];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            setList([...data]);
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName: 'line',
    };

    const createOptionGroup = (val) => {
        axios.post('/api/table/order/menu/option/group', val)
            .then((data) => {
                if (data.status === 204) {
                    getOptionGroup()
                    modalRef.current.closeModal();
                    alertRef.current.showAlert({ title: '옵션 그룹이 생성 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchOptionGroup = (val) => {
        axios.patch('/api/table/order/menu/option/group', val)
            .then((data) => {
                if (data.status === 204) {
                    getOptionGroup()
                    modalModRef.current.closeModal();
                    alertRef.current.showAlert({ title: '옵션 그룹이 수정 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const removeOptionGroup = (id) => {
        axios.delete('/api/table/order/menu/option/group/' + id)
            .then((data) => {
                if (data.status === 204) {
                    getOptionGroup()
                    modalModRef.current.closeModal();
                    alertRef.current.showAlert({ title: '옵션 그룹이 삭제 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchGroupOrder = () => {
        let arr = [];
        for (let i = 0; i < list.length; i++) {
            arr.push(list[i]._id.$oid)
        }

        axios.patch('/api/table/order/menu/option/group/re_order', {
            GroupIds: arr
        })
            .then((data) => {
                if (data.status === 204) {
                    getOptionGroup()
                    setIsDrag(false)
                    alertRef.current.showAlert({ title: '그룹 순서가 변경 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    return (
        <div className='option-group-info'>
            <div className='header-row between'>
                {/* <Input
                    style={{ width : 400 }}
                    placeholder="옵션을 검색해보세요."
                /> */}
                <div />

                <div className='row'>
                    {!isDrag && <Button variant="sub" small style={{ width: 112, marginRight: 8 }} onClick={() => tableOrderSync()}>
                        메뉴 동기화
                    </Button>}
                    {/* <Button variant="sub" small style={{ marginRight : 8, width : 112 }} onClick={() => setIsDrag(old => !old)}>
                        {isDrag ? '취소' : '순서변경'}
                    </Button> */}

                    {
                        isDrag ?
                            <Button variant="main" small style={{ width: 112 }} onClick={() => patchGroupOrder()}>
                                순서 저장
                            </Button>
                            :
                            <Button variant="main" small style={{ width: 112 }} onClick={() => modalRef.current.openModal()}>
                                옵션 그룹 추가
                            </Button>
                    }
                </div>
            </div>

            {
                isLoading ?
                    <LinearProgress color="error" />
                    :
                    <div className='divider'></div>
            }

            {
                isLoading ?
                    null
                    :
                    list.length > 0 ?
                        <ReactDragListView {...dragProps}>
                            <ol style={{ margin: 0, padding: 0 }}>
                                {
                                    list.map((data, i) => (
                                        <li key={i}>
                                            <div className='option-group-box' style={isDrag ? { padding: 24 } : {}}>
                                                <div onClick={() => { if (!isDrag) { navigate(`/tablet-order/option/${data._id.$oid}`) } }} style={{ width: '70%' }}>
                                                    <div className='row'>
                                                        <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration: '0.4s', transitionDelay: '0.2s' }}>
                                                            <p className='move-icon' style={{ width: isDrag ? 64 : 0, transition: 'all', transitionDuration: '0.2s' }}>
                                                                <div style={{cursor: 'pointer'}}>
                                                                    <img src={require('../../../../aseets/icons/menu-drag.svg').default} style={{ width: 24, height: 24, pointerEvents: "none" }} />
                                                                </div>
                                                            </p>
                                                        </Slide>
                                                        <p className='option-name'>{languageText(data.Name)}</p>
                                                    </div>
                                                    <div style={isDrag ? { display: 'none' } : {}}>
                                                        <p className={`option-desc`}>
                                                            {
                                                                data.OptionInfo.map((item, index) => {
                                                                    return languageText(item.Name) + (index === data.OptionInfo.length - 1 ? '' : ', ')
                                                                })
                                                            }
                                                        </p>
                                                        {
                                                            data.ConnectedMenuInfo.length > 0
                                                            &&
                                                            <>
                                                                <div className='option-box'>
                                                                    <p className='option-title'>옵션과 연결되어있는 메뉴를 확인해보세요.</p>
                                                                </div>
                                                                <div className='row'>
                                                                    <p className='option-title'>
                                                                        {
                                                                            data.ConnectedMenuInfo.map((item, i) => {
                                                                                return languageText(item.Name) + (i === data.ConnectedMenuInfo.length - 1 ? '' : ', ')
                                                                            })
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='row' style={{ width: 'fit-content', alignItems: 'center', justifyContent: 'center', height: isDrag ? 0 : 'fit-content', opacity: isDrag ? 0 : 1, transition: 'all', transitionDuration: '0.5s' }}>
                                                    <button className='mod-btn' onClick={() => {setData(data); modalModRef.current.openModal()}}>
                                                        수정하기
                                                    </button>
                                                    <button className='remove-btn' onClick={() => alertRef.current.showAlert({ title: `정말 옵션 그룹을 삭제하시겠어요?`, isConfirm: true, confirmText: '삭제', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); removeOptionGroup(data._id.$oid) } })}>
                                                        <img src={require('../../../../aseets/icons/delete.svg').default} style={{ width: 24, height: 24 }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    ))
                                }
                            </ol>
                        </ReactDragListView>
                        :
                        <div>
                            <p className='empty-list'>생성된 옵션이 없습니다.</p>
                        </div>
            }

            <Modal ref={modalRef} contentContainer={{ width: 500 }} isHeader title={'옵션 그룹 추가'}>
                <CreateOptionGroup createOptionGroup={createOptionGroup} info={data} />
            </Modal>

            <Modal ref={modalModRef} contentContainer={{ width: 500 }} isHeader title={'옵션 그룹 수정'}>
                <ModifyOptionGroup patchOptionGroup={patchOptionGroup} info={data} />
            </Modal>
        </div>
    )
}

export default OptionGroupInfo;